import { z } from "zod";
import type { Sarf39Snapshot } from "./sarf39-model";
const number = z.number().finite();
const snapshot = z.object({
  source: z.object({plan:z.string(),planSheet:z.string(),mikroSnapshot:z.string(),note:z.string()}),
  scope: z.object({productPrefix:z.string(),calculation:z.string()}),
  products: z.array(z.object({
    code:z.string(),name:z.string(),unit:z.string(),planQuantity:number,
    sourceRows:z.array(number),workOrders:z.array(z.string()),lineNames:z.array(z.string()),
    dailyPlan:z.array(z.object({key:z.string(),label:z.string(),quantity:number})),
    components:z.array(z.object({code:z.string(),name:z.string(),unit:z.string(),perUnit:number})),
    tree:z.array(z.object({parent:z.string(),code:z.string(),name:z.string(),unit:z.string(),level:number,directRatio:number,cumulativePerUnit:number,path:z.string()})),
  })),
});
export function parseSarf39Snapshot(value: unknown): Sarf39Snapshot {
  const result = snapshot.safeParse(value);
  if (!result.success) throw new Error("Sarf planı yanıtı geçersiz.");
  return result.data;
}
export function parseSarf39Access(value: unknown) {
  const result = z.object({expiresAt:z.string().datetime()}).safeParse(value);
  if (!result.success) throw new Error("Sarf erişim yanıtı geçersiz.");
  return result.data;
}
